import '../../../../main';

import Vue from 'vue';
import quoteFormStep1 from '../../../../section-specific/applications/application-img/quote-form-step1';

Vue.component('quote-form-step1', quoteFormStep1);

require('../application-entry-common');
